import queryString from "query-string";
function getUrlOrderType(type) {
    switch (type) {
        case "equity":
        case "futureSpread":
            return "";
        default:
            return `/${type}`;
    }
}
function getUrlFillOrderType(type) {
    switch (type) {
        case "equity":
            return "listed";
        case "futureSpread":
            return "futurespread";
        case "cdx":
            return "cds";
        default:
            return `${type}`;
    }
}
export const fillVoiceOrderFactory = (restServer) => {
    return function fillVoiceOrder(type, body, acceptWarnings, abortController) {
        return restServer(queryString.stringifyUrl({
            url: `/internal/api/oms/v1/orders/fill/${getUrlFillOrderType(type)}`,
            query: {
                acceptWarnings,
            },
        }), {
            body,
            signal: abortController?.signal,
        });
    };
};
export const saveOrderFactory = (restServer) => {
    return function saveOrder(type, body, query = {}, abortController) {
        return restServer(queryString.stringifyUrl({
            url: `/internal/api/oms/v1/orders${getUrlOrderType(type)}/save`,
            query,
        }), { signal: abortController?.signal, body });
    };
};
export const saveAndTransmitOrderFactory = (restServer) => {
    return function saveAndTransmitOrder(type, body, query = {}, abortController) {
        return restServer(queryString.stringifyUrl({
            url: `/internal/api/oms/v1/orders${getUrlOrderType(type)}/save/transmit`,
            query,
        }), { signal: abortController?.signal, body });
    };
};
export const getSplitOrderFactory = (restServer) => {
    return function getSplitOrder(type, parentOrderId, abortController) {
        return restServer(queryString.stringifyUrl({
            url: `/internal/api/oms/v1/orders/split${getUrlOrderType(type)}`,
            query: {
                parentOrderId,
            },
        }), {
            signal: abortController?.signal,
        });
    };
};
export const getOrderFactory = (restServer) => {
    return function getOrder(type, orderId, abortController) {
        return restServer(queryString.stringifyUrl({
            url: `/internal/api/oms/v1/orders${getUrlOrderType(type)}/${orderId}`,
        }), {
            signal: abortController?.signal,
        });
    };
};
